import { ClientTicketStatus } from '@bustickus/models-client';

function getTicketStatusClass(status: ClientTicketStatus): string {
  if (status === 'active' || status === 'archive' || status === 'refund') {
    return 't-s-UUq9';
  }

  if (status === 'payment_waiting') {
    return 't-w-17Fi';
  }

  return 't-e-2Grx';
}

export default getTicketStatusClass;
